// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._15gov0c0 {
  border-top: 2px solid var(--_18w76bw28);
}
@media screen and (min-width: 1024px) {
  ._15gov0c1 {
    max-width: 220px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["._15gov0c0 {\n  border-top: 2px solid var(--_18w76bw28);\n}\n@media screen and (min-width: 1024px) {\n  ._15gov0c1 {\n    max-width: 220px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
